import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

/**
 * These attributes are only populated for moderators and for an alt's own
 * owner. For everybody else the server reports isAlt: false, so nothing here
 * leaks the existence of an alt.
 */
export default function extendUserModel() {
  User.prototype.isAlt = Model.attribute('isAlt');
  User.prototype.altOwnerId = Model.attribute('altOwnerId');
  User.prototype.altOwnerUsername = Model.attribute('altOwnerUsername');
  User.prototype.altRetiredAt = Model.attribute('altRetiredAt', Model.transformDate);
}
